import {
    Box,
    Button,
    InputAdornment,
    Stack,
    Tooltip,
    Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonModel from "../../../components/dialog/Common";
import useDebounce from "../../../hooks/use.debounce";
import { deleteCommunityPost, getAllCommunityPosts } from "../action";
import NotificationType from "../group/notificationType";
import { CustomSearchInput, TOOLTIP_STYLES, trunCateString } from "../../../utils/constant";
import searchIcon from "../../../assets/images/icons/searchIcon.svg"
import CustomPagination from "../../../utils/CustomPagination";
import { resetCommunityPostSlice, updateCommunityPostSlice } from "./communityPostsSlice";
import dayjs from "dayjs";
const formatTimestamp = (timestamp, tz = "Asia/Kolkata") => {
    return dayjs(timestamp).format("D MMM YYYY");
};

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, isSticky, } = props;
    const createSortHandler =
        (property) => (event) => {
            if (["noofUsers"].includes(property)) {
                onRequestSort(event, property);
            } else {
                return;
            }
        };


    const headCells = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Name",
            type: "",
        },
        {
            id: "description",
            numeric: false,
            disablePadding: true,
            label: "Post Description",
            type: "",
        },
        {
            id: "last",
            numeric: false,
            disablePadding: true,
            label: "Last Updated",
            type: "",
        },
        {
            id: "action",
            numeric: false,
            disablePadding: true,
            label: "Actions",
            type: "",
        },
    ];

    return (
        <TableHead className={`hideActionSort ${isSticky} `}>
            <TableRow sx={{
                background: '#DBECFF !important', height: "50px", "& th": {
                    backgroundColor: "inherit !important"
                },
            }}>
                <TableCell>
                </TableCell>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


export default function CommunityPosts(props) {
    const navigate = useNavigate();
    const states = useSelector((state) => state.app);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("noofUsers");
    const [open, setOpen] = useState(0);
    const [ids, setIds] = useState([]);
    const [sticky, setSticky] = useState("");
    const [open1, setOpen1] = useState(false);
    const dispatch = useDispatch();
    const {
        limit,
        page,
        sortKey = "",
        totalCount,
        totalPages,
        filters,
        list,
    } = useSelector((state) => state.communityPostSlice);
    const debouncedSearch = useDebounce(filters.search, 500);
    const handleRequestSort = (
        event,
        property
    ) => {
        const isAsc = orderBy === property && order === "asc";

        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        dispatch(
            updateCommunityPostSlice({
                sortType: isAsc ? "asc" : "desc",
                sortKey: property,
            }),
        );
        dispatch(getAllCommunityPosts())
    };

    useEffect(() => {
        if (debouncedSearch || filters.search == "")
            dispatch(getAllCommunityPosts())
    }, [debouncedSearch]);

    useEffect(() => {
        dispatch(getAllCommunityPosts())
        return () => dispatch(resetCommunityPostSlice())
    }, []);

    const handleSearch = (event) => {
        dispatch(updateCommunityPostSlice({ filters: { ...filters, search: event.target.value } }));
    };

    const handleSearchClear = () => {
        dispatch(updateCommunityPostSlice({ filters: { ...filters, search: "" } }));
        dispatch(getAllCommunityPosts());
    };

    const handleChange = (value) => {
        dispatch(updateCommunityPostSlice({ page: value - 1 }));
        dispatch(getAllCommunityPosts());
    };
    const handleChangePerPage = (event, value) => {
        dispatch(updateCommunityPostSlice({ limit: event.target.value, page: 0 }));
        dispatch(getAllCommunityPosts());
    };

    return (
        <>
            <Stack direction={"column"} gap={2}>
                <Stack
                    className="mainTitle flex-wrap"
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px', paddingX: '16px'
                    }}
                >
                    <Typography className="page-title" variant="h1">Community Posts</Typography>
                    <Stack direction={"row"} gap={2}>
                        <CustomSearchInput
                            className="inputSearch sContrl p-0"
                            value={filters.search}
                            placeholder={"Search here..."}
                            handleSearch={handleSearch}
                            clearSearch={handleSearchClear}
                            startAdornment={
                                <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                                    sx={{
                                        maxHeight: 'none',
                                        height: '38px',
                                        minWidth: '38px',
                                        marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                                    }}
                                >
                                    <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                                </InputAdornment>
                            }
                        />
                        <Button className="btnPrimary" variant="contained"
                            onClick={() => navigate("/notification/communityposts/add")}
                        >
                            Create Posts
                        </Button>
                    </Stack>
                </Stack>
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        transition: 'all .5s ease-in-out',
                        position: 'relative',
                    }}>
                    <TableContainer>
                        <Table
                            stickyHeader aria-label="sticky table"
                        >
                            <EnhancedTableHead
                                isSticky={sticky}
                                order={order}
                                orderBy={sortKey}
                                listing={list}
                                setIds={setIds}
                                ids={ids}
                                onRequestSort={handleRequestSort}
                                numSelected={0}
                                onSelectAllClick={function (

                                ) {
                                    throw new Error("Function not implemented.");
                                }}
                            />
                            <TableBody>
                                {list?.length > 0 ? (
                                    list?.map((row, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row?.id}
                                                sx={{
                                                    "&:hover": {
                                                        backgroundColor: '#F0F7FF !important', "& td": {
                                                            backgroundColor: "inherit !important"
                                                        },
                                                    }, height: '60px'
                                                }}
                                            >
                                                <TableCell>

                                                </TableCell>

                                                <TableCell component="td" scope="row">
                                                    <Tooltip title={row.name} componentsProps={TOOLTIP_STYLES} arrow>
                                                    {trunCateString(row?.name,20) || "N/A"}
                                                    </Tooltip>

                                                </TableCell>

                                                <TableCell align="left">
                                                    {trunCateString(row?.description,40 )|| "N/A"}

                                                </TableCell>
                                                <TableCell align="left">
                                                    {formatTimestamp(row.createdDate)}
                                                </TableCell>

                                                <TableCell sx={{ cursor: "pointer" }}>
                                                    <Stack direction={"row"} gap={2}>
                                                        <div className="actBtnGrps">
                                                            {states?.permissions?.groups?.edit == 1 || true && <span className="editIcon" onClick={() => navigate(`/notification/communityposts/edit`, { state: row })}>Edit</span>}
                                                            <span className="viewIcon" style={{ color: "red" }} onClick={() => {
                                                                setOpen(row.id)
                                                            }}>
                                                                Delete
                                                            </span>
                                                        </div>

                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow colSpan={10}>
                                        <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                                            <Typography
                                                color="inherit"
                                                variant="subtitle1"
                                                alignItems={"center"}
                                                component="h3"
                                            >
                                                No Data found!
                                            </Typography>

                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                    </TableContainer>
                    <Stack
                        sx={{
                            background: 'transparent',
                            height: '60px',
                            border: '1px solid #E9EAEB'
                        }}
                        direction="row"
                        alignItems={"center"}
                        justifyContent={"flex-end"}>
                        <CustomPagination
                            count={Math.ceil(totalPages / limit) || 0}
                            onChange={handleChange}
                            currentPage={page}
                            handleChangePerPage={handleChangePerPage}
                            limit={limit}
                            listingCount={list?.length}
                            totalCount={totalCount}
                            defaultPage={1} siblingCount={1} boundaryCount={1} />
                    </Stack>
                    <CommonModel
                        open={Boolean(open)}
                        handleDialogClose={() => setOpen(false)}
                        dialogTitle={"Delete Post"}
                        dialogPara={`Are you sure, you want to delete this post?`}
                        nvYes={"Yes"}
                        className={"btnDanger"}
                        nvCancel={"Cancel"}
                        yesHandle={() => {
                            setIds(ids.filter((v) => v !== open))
                            dispatch(deleteCommunityPost(open))
                            setOpen(false);
                        }}
                    />
                </Box>

                <NotificationType
                    setOpen={setOpen1}
                    open={open1}
                    ids={ids}
                />


            </Stack>

        </>
    );
}
